import type {Permissions} from '@nursio-link/common/authorization';
import {isAuthorized} from '@nursio-link/common/authorization';

import {getGroups} from '@/services/authService';

export const isCurrentGroupsAuthorized = async (permission: Permissions) => {
  const roles = await getGroups();
  if (!roles) return false;
  return isAuthorized(roles, permission);
};

export default isCurrentGroupsAuthorized;
